module.exports = {
      id: "gallery-scope-usage",
      viewBox: "0 0 32 32",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#gallery-scope",
      toString: function () {
        return this.url;
      }
    }